// Antiplagiarism report share status enum
export enum AntiplagiarismReportShareStatus {
    SHARED = 'SHARED',
    NOT_SHARED = 'NOT_SHARED',
}
export enum QuickMarkType {
    COMMENT = 'COMMENT',
    CRITERIA = 'CRITERIA',
}

export enum CandidateLevelWorkflowState {
    NOT_STARTED = 'NOT_STARTED',
    PRIVATE = 'PRIVATE',
    PENDING_SHARE = 'PENDING_SHARE',
    SHARED_CONFLICTS = 'SHARED_CONFLICTS',
    SHARED = 'SHARED',
    PENDING_CONFIRM = 'PENDING_CONFIRM',
    CONFIRMED = 'CONFIRMED',
}

export enum AssessmentRunContributorStatus {
    INVITED = 'INVITED',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
    IN_PROGRESS = 'IN_PROGRESS',
    DRAFT = 'DRAFT',
    COMPLETE = 'COMPLETE',
}

export enum ExternalSystem {
    PCG = 'PCG',
    FS = 'FS',
    LADOK = 'Ladok',
    LTI = 'LTI',
    CAMBRIDGE = 'Cambridge',
    CIE = 'CIE',
    CXC = 'CXC',
    INVITATION_CODE = 'InvitationCode',
    API = 'API',
}

export enum ExternalDeliveryStatus {
    CONFIRMED = 'CONFIRMED',
}

export enum FileErrorTypes {
    FILE_UPLOAD_ERROR = 'fileUploadError',
    FILE_FORMAT_ERROR ='fileFormatError',
    FILE_CONTENT_NOT_SUPPORTED_ERROR = 'fileContentNotSupportedError',
    FILE_TYPE_NOT_SUPPORTED = 'fileTypeNotSupported',
}

export enum FileUploadInfo {
    SET = 'Set',
    SENT = 'Sent',
    MARKS = 'Marks',
    GRADE = 'Grade',
}

export enum FileType {
    MARKS = 'marks',
    GRADE = 'grade',
}
